module.exports = __webpack_public_path__ + "static/img/2_10.45f81b8c.jpg";